import React from 'react';
import SignupForm from './SignupForm';

const Signup = () => (

  <div>
    <SignupForm />
  </div>
);

export default Signup;
